import React, { FC } from 'react';
import SxProps from 'threads5/themes/sx-props';
import type { ITheme } from 'threads5/themes/theme';

import styled from 'threads5/styles/styled';
import { Button as ButtonUnstyled } from '@mui/base/Button';

const StyledButton = styled(ButtonUnstyled)({
  backgroundColor: 'white',
  color: 'black',
  border: '2px solid black',
  borderRadius: '50% !important',
  width: '88px',
  height: '88px',
  cursor: 'pointer',
  '&:hover, &:focus': {
    color: 'black',
    backgroundColor: 'white',
  },
  '&:active': {
    color: 'black',
    backgroundColor: 'black',
  },
  '& svg': {
    zoom: 2,
  },
  transition: 'background-color 0.3s ease-in-out, color 0.3s ease-in-out',
});
const StyledSpan = styled('span')(() => {
  return {
    fontSize: '24px',
    marginLeft: '5px',
  };
});

interface Props {
  onClick?: (event) => void;
  sx?: SxProps<ITheme>;
  playIcon?: React.ReactNode;
}

const PlayButton: FC<Props> = ({ onClick, sx = {}, playIcon }) => {
  return (
    <StyledButton aria-label='Play' onClick={onClick} sx={sx}>
      {playIcon ? playIcon : <StyledSpan>&#9658;</StyledSpan>}
    </StyledButton>
  );
};

export default PlayButton;
